import { useTranslation } from 'react-i18next';

export const keyPrefix = 'toggle_top_match';
export const useToggleTopMatchTranslation = () => useTranslation('features', { keyPrefix });

export const ruRu = ({
  [keyPrefix]: {
    label: 'Отображать наибольшее совпадение',
  },
}) as Record<string, unknown>;

export const en = ({
  [keyPrefix]: {
    label: 'Display top match',
  },
}) as Record<string, unknown>;

export const ptBr = ({
  [keyPrefix]: {
    label: 'Mostrar melhor correspondência',
  },
}) as Record<string, unknown>;

export const esEs = ({
  [keyPrefix]: {
    label: 'Mostrar mejor coincidencia',
  },
}) as Record<string, unknown>;
